import '../css/adm-product-page-configurations.scss';
import '../css/vendor/_colorbox.scss';
import namespace from './upi/namespace';
import $ from '@modules/jquery-import';
import {jqueryDropDownMenu} from '@modules/lazy-imports';

function autoResizeHeight() {
    this.height = this.contentWindow.document.body.scrollHeight + 'px';
}

var Page = namespace( 'Page' ), $innerFrame, $innerFrameDoc;

var dialogSettings = {
    resize: true,
    close: '',
    opacity: 0.7,
    transition: 'none',
    iframe: true,
    width: '100%',
    maxWidth: 960,
    height: '100%',
    overlayClose: false,
    onLoad: function () {
        $( '#cboxTitle' ).remove();
    },
    onOpen: function () {
        $( 'body' ).addClass( 'nopad' );
    },
    onClosed: function () {
        $( 'body' ).removeClass( 'nopad' );
    },
    onComplete: function () {
        // CRUD operations within these iframes currently trigger a page refresh inside the frame
        // because of this we must first listen to load/unload events on the iframe itself
        // then bind to click events on the document window inside the iframe
        // anytime an operation occurs we cleanup listening on load/unload events on inner document then rebind again
        // closing the dialog will clear out everything
        $innerFrame = $( '#colorbox' ).find( 'iframe' );
        $innerFrame.on( 'load', function () {
            $innerFrameDoc = $( $innerFrame.get( 0 ).contentWindow );
            $innerFrameDoc.on(
                'click',
                '.delete, [id$="btnDelete"]',
                Page.ConfiguratorAdmin.handleDelete
            );
        } );
        $innerFrame.on( 'unload', function () {
            $innerFrameDoc.off( 'click', Page.ConfiguratorAdmin.handleDelete );
        } );
    },
    onCleanup: function () {
        $innerFrame.off( 'load unload' );
        $innerFrameDoc.off( 'click' );
        $innerFrame = null;
        $innerFrameDoc = null;
    }
};

Page.ConfiguratorAdmin = {
    nodes: {
        $buttonDropdown: '.button.dropDownSelect',
        $modalButtons: '[data-modal]',
        $headings: '.heading',
        $attributeGroupButton: '.action-list .button:contains(Add Top Level Attribute)',
        $cardSection: '.card-section'
    },

    getNodes: function ( nodes ) {
        nodes['$cont'] = $( '#adm-configurations' );

        for ( var node in nodes ) {
            if ( nodes.hasOwnProperty( node ) ) {
                nodes[node] = nodes.$cont.find( nodes[node] );
            }
        }
    },

    openDialog: function ( href ) {
        var settings;

        if ( !href ) {
            return false;
        }

        settings = $.extend( dialogSettings, {href: href} );
        $.colorbox( settings );
    },

    init: function () {
        this.getNodes( this.nodes );

        var self = this;

        // init drop down menus
        jqueryDropDownMenu().then( () => this.nodes.$buttonDropdown.dropDownSelect() );

        $( 'iframe' ).on( 'load', function () {
            $.colorbox.resize();
        } );

        // note -> overwrite form submit to prevent multiple form submissions
        const form = document.getElementById( 'form1' );
        form.onsubmit = ( e ) => {
            if ( this.formIsSubmitting ) {
                console.warn( '[Duplicated submission] - Form submission appeared to be duplicate and was prevented' );
                return false;
            }
            if ( typeof (ValidatorOnSubmit) == 'function' && ValidatorOnSubmit() == false ) {
                return false;
            }

            this.formIsSubmitting = true;
            return true;
        };

        // hide empty .heaading elements
        this.nodes.$headings.each( function () {
            var $heading = $( this );
            !$heading.text().trim() && $heading.hide();
        } );

        this.nodes.$modalButtons.colorbox( dialogSettings );

        upi.colorboxClose = function () {
            $.colorbox.close();
        };

        // patch - change class and label on attribute (group level) buttons
        this.nodes.$attributeGroupButton.html(
            '<i class="icon-at"></i> Add Attribute List'
        );
        // patch - remove "Add Attribute List" button from main group actions once an item has been added to a collection
        this.nodes.$attributeGroupButton.each( removeIfCollectionNotEmpty );
        // patch - toggle sku icon on groups that will display as a sku
        this.nodes.$cardSection.each( toggleIfSku );
        // patch - receed unlabeled headings
        this.nodes.$headings.each( toggleUnlabeledHeading );
        // patch - hide group actions if in an attribute collection
        this.nodes.$headings.each( hideActionsIfAttributeCollection );
    },

    handleDelete: function () {
        var orgHandler = this.onclick || function () {
            },
            confirmed = confirm( 'Are you sure? This action can not be undone.' );

        return confirmed ? orgHandler() : false;
    }
};

$( function () {
    import( /*webpackChunkName: "~~jquery-colorbox"*/ 'jquery-colorbox' ).then( () => {
        Page.ConfiguratorAdmin.init();
    } );
} );

// helpers
function toggleIfSku( i, item ) {
    var $card = $( item ), $skuListItems = $card.find( '.sku-list dl' );

    if (
        $skuListItems.length === 1 &&
        !$card.find( '.attribute-list-collection > *' ).length
    ) {
        $card.addClass( 'sku-group' );
    }
}

function removeIfCollectionNotEmpty( i, item ) {
    var $attributeButton = $( item ),
        hasContent = !!$attributeButton
            .parents( '.mod-bd' )
            .find( '.card-section' )
            .text()
            .trim();

    if ( hasContent ) {
        $attributeButton.hide();
    }
}

// remove dark background from headings that do not represent a label in the configurator UI
function toggleUnlabeledHeading( i, item ) {
    var $heading = $( item );
    if ( /Attribute Collection/.test( $heading.text() ) ) {
        $heading.addClass( 'receed' );
    }
}

function hideActionsIfAttributeCollection( i, item ) {
    var $heading = $( item );

    if ( !$heading.text().trim() && $heading.next().find( 'li' ).length > 0 ) {
        $heading.parents( '.mod-bd' ).find( '> .action-list' ).hide();
    }
}
